import React from 'react';
import randomMC from 'random-material-color';
/**
 * Vracia farbu Avataru vypocitanu na zaklade 'name' .
 *
 * @param {{name: string}} param0
 * @returns {string} Vypocitana farba v CSS formate ('#XXYYZZ').
 */

export default function useTextToMaterialColor(text) {
  return React.useMemo(function () {
    return randomMC.getColor({
      text: text
    });
  }, [text]);
}